<template>
  <div class="sm-activity">
    <h4>Mail activity per month</h4>
    <table class="sm-table sm-activity__table">
      <thead>
        <tr>
          <th 
            class="sort sm-txt-upper"
            :class="currentSort === 'year' && currentSortDir === 'asc' ? 'active' : ''" 
            @click="sortBy('year')"
          >
            Year
            <include-svg :name="'icon-arrow-b-bold'" />
          </th>
          <th 
            class="sort sm-txt-upper"
            :class="currentSort === 'month' && currentSortDir === 'asc' ? 'active' : ''" 
            @click="sortBy('month')"
          >
            Month
            <include-svg :name="'icon-arrow-b-bold'" />
          </th>
          <th class="sm-txt-upper">Scans</th>
          <th class="sm-txt-upper">Forwards</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr 
          v-for="item in userActivity" 
          :key="item.id"
        >
          <td>{{item.year}}</td>
          <td>{{item.month}}</td>
          <td>{{item.scans}}</td>
          <td>{{item.forwards}}</td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <sm-spinner :show="!userActivity.length" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Months from '@/settings/month';
import Spinner from '@/components/Spinner';

export default {
  name: 'tab-activity',
  components: {
    "sm-spinner": Spinner,
  },
  data() {
    return {
      userActivity: [],
      currentSort: 'year',
      currentSortDir: 'desc',
    }
  },
  created() {
    this.getActivity();
  },
  computed: {
    ...mapGetters({
      activity: 'account/userStats'
    })
  },
  methods: {
    ...mapActions({
      getActivity: 'account/getActivity'
    }),
    sortBy(key) {
      if (key === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'desc' ? 'asc' : 'desc';
      } else {
        this.currentSortDir = 'desc';
        this.currentSort = key;
      }

      this.userActivity.sort((a, b) => {
        if (key === 'year') {
          return this.currentSortDir === 'desc' ? a[key] - b[key] : b[key] - a[key];
        } else if (key === 'month') {
          if (a[key] === b[key]) {
            return 0;
          }
          else {
            if (this.currentSortDir === 'desc') {
              return (a[key] < b[key]) ? -1 : 1;
            } else {
              return (a[key] > b[key]) ? -1 : 1;
            }
          }
        }

      })
    }
  },
  watch: {
    activity(val) {
      Object.keys(val).forEach((date, i) => {
        let splDate = date.split('-');

        this.userActivity.push({
          id: i,
          year: splDate[0],
          month: Months.en[parseInt(splDate[1]) - 1],
          scans: val[date].scanned,
          forwards: val[date].forwarded
        })
      });
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/general/mixins.scss";
  @import "@/assets/scss/framework/scss-variables.scss";
  @import "@/assets/scss/pages/customer/account/components/_activity.scss";
</style>